export default __webpack_public_path__ + "static/media/0186.78c563c1.jpg";